import { getForm } from '@wix/ambassador-forms-v4-form/http';
import { getFieldPropertiesByTarget as _getFieldPropertiesByTarget } from '@wix/form-schema';
async function fetchFormSchema({ formId, httpClient, errorHandler, }) {
    try {
        const response = await errorHandler.withErrorHandler(() => httpClient.request(getForm({
            formId,
        })), { errorCodesMap: {} });
        return response.data.form;
    }
    catch (e) {
        errorHandler.showError(e);
        if (!process.env.JEST_WORKER_ID) {
            console.error('Failed to load form to check isFormEmpty');
        }
        return undefined;
    }
}
export function isEmpty(form) {
    if (!form.fields) {
        return true;
    }
    return form.fields.filter((f) => !f.hidden).length === 0;
}
export function isFormEmptyBuilder(formsById) {
    return function (formId) {
        const form = formsById[formId];
        if (!form) {
            return null;
        }
        return isEmpty(form);
    };
}
export async function isFormEmpty({ httpClient, formId, errorHandler, }) {
    const form = await fetchFormSchema({
        formId,
        httpClient,
        errorHandler,
    });
    if (form === undefined) {
        return null;
    }
    return isEmpty(form);
}
export function isFormDisabledBuilder(formsById) {
    return function (formId) {
        const form = formsById[formId];
        return !!form?.properties?.disabled;
    };
}
export async function getFieldPropertiesByTarget({ httpClient, formId, options, errorHandler, }) {
    const form = await fetchFormSchema({
        formId,
        httpClient,
        errorHandler,
    });
    if (form === undefined) {
        return undefined;
    }
    return _getFieldPropertiesByTarget(form, options);
}
//# sourceMappingURL=form-utils.js.map